(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gift-box-builder"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const root = document.querySelector('.giftbox-builder');
    if (!root) return;

    const STORAGE_KEY = 'giftbox_active_box';
    const minItems = parseInt(root.dataset.minItems || '1', 10);
    const maxItems = parseInt(root.dataset.maxItems || '0', 10);
    const boxLabel = root.dataset.boxLabel || 'Geluksbox';
    const moneyFormat = root.dataset.moneyFormat || '€{{amount}}';
    const pageUrl = root.dataset.giftboxPageUrl || window.location.pathname;

    const overviewList = document.getElementById('giftbox-overview-list');
    const overviewEmpty = document.getElementById('giftbox-overview-empty');
    const countEl = document.getElementById('giftbox-count');
    const totalEl = document.getElementById('giftbox-total');
    const submitBtn = document.getElementById('giftbox-submit');
    const errorEl = document.getElementById('giftbox-error');
    const actionsBuilding = document.getElementById('giftbox-actions-building');
    const actionsDone = document.getElementById('giftbox-actions-done');
    const restartBtn = document.getElementById('giftbox-restart');
    const radios = root.querySelectorAll('input[name="giftbox-packaging"]');
    const messageWrapper = document.getElementById('giftbox-packaging-message');
    const messageInput = document.getElementById('giftbox-message');
    const messageCountEl = document.getElementById('giftbox-message-count');
    const searchInput = document.getElementById('giftbox-search');
    const browseItems = root.querySelectorAll('.giftbox-browse-item');
    const noResultsEl = document.getElementById('giftbox-browse-no-results');

    function getActiveBox() {
      try {
        const raw = sessionStorage.getItem(STORAGE_KEY);
        return raw ? JSON.parse(raw) : null;
      } catch (e) {
        return null;
      }
    }
    function setActiveBox(box) {
      try { sessionStorage.setItem(STORAGE_KEY, JSON.stringify(box)); } catch (e) {}
    }
    function clearActiveBox() {
      try { sessionStorage.removeItem(STORAGE_KEY); } catch (e) {}
    }
    function ensureActiveBox() {
      let box = getActiveBox();
      if (!box || !box.boxId) {
        box = {
          boxId: 'box-' + Date.now(),
          boxName: boxLabel,
          minItems: minItems,
          maxItems: maxItems,
          pageUrl: pageUrl
        };
      } else {
        box.minItems = minItems;
        box.maxItems = maxItems;
        box.pageUrl = pageUrl;
      }
      setActiveBox(box);
      return box;
    }

    function formatMoney(cents) {
      const amount = (cents / 100).toFixed(2).replace('.', ',');
      const withThousands = amount.replace(/\B(?=(\d{3})+(?=,))/g, '.');
      return moneyFormat.replace(/\{\{\s*amount[a-zA-Z_]*\s*\}\}/, withThousands);
    }

    function showBuildingState() {
      actionsBuilding.hidden = false;
      actionsDone.hidden = true;
    }
    function showDoneState() {
      actionsBuilding.hidden = true;
      actionsDone.hidden = false;
    }

    let currentBox = ensureActiveBox();

    function refreshOverview() {
      fetch('/cart.js', { cache: 'no-store' })
        .then((res) => res.json())
        .then((cart) => {
          const productLines = cart.items.filter((item) =>
            item.properties && item.properties['_box_id'] === currentBox.boxId && item.properties['_type'] !== 'verpakking'
          );

          // Belangrijk: als hetzelfde product/dezelfde variant nogmaals wordt
          // toegevoegd aan dezelfde box, voegt Shopify dit samen tot ÉÉN regel
          // met een hogere quantity, in plaats van een nieuwe regel aan te maken.
          // Daarom tellen we hier de som van alle quantities, niet het aantal regels.
          const itemCount = productLines.reduce((sum, item) => sum + item.quantity, 0);

          overviewList.innerHTML = '';
          if (productLines.length === 0) {
            overviewList.appendChild(overviewEmpty);
          } else {
            productLines.forEach((item) => {
              const li = document.createElement('li');
              li.className = 'giftbox-overview__item';
              const quantityLabel = item.quantity > 1 ? ' × ' + item.quantity : '';
              li.innerHTML =
                '<img src="' + (item.image || '') + '" alt="" width="48" height="48">' +
                '<span class="giftbox-overview__item-title">' + item.product_title + quantityLabel + '</span>' +
                '<span class="giftbox-overview__item-price">' + formatMoney(item.final_line_price) + '</span>' +
                '<button type="button" class="giftbox-overview__item-remove" data-line-key="' + item.key + '">Verwijder</button>';
              overviewList.appendChild(li);
            });
          }

          const packagingRadio = root.querySelector('input[name="giftbox-packaging"]:checked');
          let totalCents = productLines.reduce((sum, item) => sum + item.final_line_price, 0);
          if (packagingRadio) totalCents += parseInt(packagingRadio.dataset.price || '0', 10);

          countEl.textContent = itemCount;
          totalEl.textContent = formatMoney(totalCents);

          const packagingChosen = radios.length === 0 || !!packagingRadio;
          const countValid = itemCount >= minItems && itemCount <= maxItems;
          submitBtn.disabled = !(countValid && packagingChosen);

          if (itemCount > maxItems) {
            errorEl.textContent = 'Je hebt te veel artikelen gekozen (max. ' + maxItems + '). Verwijder er een aantal.';
            errorEl.hidden = false;
          } else {
            errorEl.hidden = true;
          }
        })
        .catch(() => {});
    }

    overviewList.addEventListener('click', function (e) {
      const btn = e.target.closest('[data-line-key]');
      if (!btn) return;
      const key = btn.dataset.lineKey;
      btn.disabled = true;
      btn.textContent = 'Bezig...';
      const updates = {};
      updates[key] = 0;
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates: updates })
      })
        .then(() => refreshOverview())
        .catch(() => {
          btn.disabled = false;
          btn.textContent = 'Verwijder';
        });
    });

    function updateMessageVisibility() {
      const checked = root.querySelector('input[name="giftbox-packaging"]:checked');
      const allowsMessage = checked && checked.dataset.allowsMessage === 'true';
      if (!messageWrapper) return;
      messageWrapper.hidden = !allowsMessage;
      if (!allowsMessage && messageInput) {
        messageInput.value = '';
        if (messageCountEl) messageCountEl.textContent = '0';
      }
    }
    if (messageInput && messageCountEl) {
      messageInput.addEventListener('input', function () {
        messageCountEl.textContent = messageInput.value.length;
      });
    }
    radios.forEach((r) => r.addEventListener('change', function () {
      updateMessageVisibility();
      refreshOverview();
    }));

    submitBtn.addEventListener('click', function () {
      errorEl.hidden = true;
      const packagingInput = root.querySelector('input[name="giftbox-packaging"]:checked');

      if (radios.length > 0 && !packagingInput) {
        errorEl.textContent = 'Kies een verpakking.';
        errorEl.hidden = false;
        return;
      }

      submitBtn.disabled = true;
      submitBtn.textContent = 'Bezig met afronden...';

      function finish() {
        clearActiveBox();
        showDoneState();
      }

      if (packagingInput) {
        const properties = {
          '_box_id': currentBox.boxId,
          '_box_naam': currentBox.boxName,
          '_type': 'verpakking'
        };
        const allowsMessage = packagingInput.dataset.allowsMessage === 'true';
        const messageValue = messageInput ? messageInput.value.trim() : '';
        if (allowsMessage && messageValue) {
          properties['Bedrukking binnenkant doos'] = messageValue;
        }

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: parseInt(packagingInput.value, 10), quantity: 1, properties: properties })
        })
          .then((res) => {
            if (!res.ok) throw new Error('Toevoegen mislukt');
            return res.json();
          })
          .then(finish)
          .catch(() => {
            errorEl.textContent = 'Er ging iets mis bij het afronden. Probeer opnieuw.';
            errorEl.hidden = false;
            submitBtn.disabled = false;
            submitBtn.textContent = 'Box afronden';
          });
      } else {
        finish();
      }
    });

    restartBtn.addEventListener('click', function () {
      currentBox = {
        boxId: 'box-' + Date.now(),
        boxName: boxLabel,
        minItems: minItems,
        maxItems: maxItems,
        pageUrl: pageUrl
      };
      setActiveBox(currentBox);
      radios.forEach((r) => { r.checked = false; });
      if (messageInput) messageInput.value = '';
      if (messageCountEl) messageCountEl.textContent = '0';
      updateMessageVisibility();
      submitBtn.textContent = 'Box afronden';
      showBuildingState();
      refreshOverview();
    });

    if (searchInput) {
      searchInput.addEventListener('input', function () {
        const query = searchInput.value.trim().toLowerCase();
        let visibleCount = 0;
        browseItems.forEach((item) => {
          const match = item.dataset.productTitle.indexOf(query) !== -1;
          item.hidden = !match;
          if (match) visibleCount += 1;
        });
        if (noResultsEl) noResultsEl.hidden = visibleCount !== 0;
      });
    }

    showBuildingState();
    updateMessageVisibility();
    refreshOverview();

    window.addEventListener('pageshow', function () {
      currentBox = ensureActiveBox();
      refreshOverview();
    });
  });

  } catch(e) { console.error(e); }
})();
})();
